import { populateServiceData } from './initDataLoad';
import esArray from 'src/general_components/functionEsArray';

export const saveData = async (response) => {
    /**
     * Esta funcion recibe como parametros un objeto proveniente de la respuesta del login.
     * Guarda la informacion obtenida y devuelve true o false para indicar si pudo recuperar los datos o no
     */
    const { wsResponse } = response;
    if (response.status === "true") {
        const module_menu = wsResponse.module_menu;
        const user_data = wsResponse.user_data;

        let user_cuenta = [];
        let user_cuentas_localizaciones = [];
        let user_cuentas_parametros = [];
        if (wsResponse.cuentas && wsResponse.cuentas.usuarios_cuentas) {
            user_cuenta.push(wsResponse.cuentas.usuarios_cuentas.usuarios_cuentas)
        }

        if (wsResponse.cuentas && wsResponse.cuentas.usuarios_cuentas_localizaciones) {
            user_cuentas_localizaciones = esArray(wsResponse.cuentas.usuarios_cuentas_localizaciones.usuarios_cuentas_localizaciones);
        }

        if (wsResponse.cuentas && wsResponse.cuentas.cuentas_parametros) {
            user_cuentas_parametros = esArray(wsResponse.cuentas.cuentas_parametros.cuentas_parametros);
        }
        
        if (wsResponse.cuentas && wsResponse.cuentas[0]) {
            wsResponse.cuentas.forEach((cuentas) => {
                user_cuenta.push(cuentas.usuarios_cuentas)

                if (cuentas.usuarios_cuentas_localizaciones) {
                    if(Array.isArray(cuentas.usuarios_cuentas_localizaciones.usuarios_cuentas_localizaciones)){
                        cuentas.usuarios_cuentas_localizaciones.usuarios_cuentas_localizaciones.forEach((cuentas_localizaciones) => {
                            user_cuentas_localizaciones.push(cuentas_localizaciones)
                        })
                    }else{
                        user_cuentas_localizaciones.push(cuentas.usuarios_cuentas_localizaciones.usuarios_cuentas_localizaciones
                        )
                    }
                    
                }


                if (cuentas.cuentas_parametros) {
                    if(Array.isArray(cuentas.cuentas_parametros.cuentas_parametros)){
                        cuentas.cuentas_parametros.cuentas_parametros.forEach((cuenta_parametro) => {
                            user_cuentas_parametros.push(cuenta_parametro)
                        })
                    }else{
                        user_cuentas_parametros.push(cuentas.cuentas_parametros.cuentas_parametros
                        )
                    }
                }
                
            })
        }



        if (!Array.isArray(user_cuenta)) {
            user_cuenta = [user_cuenta]
        }
        
        if (!Array.isArray(user_cuentas_localizaciones)) {
            user_cuentas_localizaciones = [user_cuentas_localizaciones]
        }

         if (!Array.isArray(user_cuentas_parametros)) {
            user_cuentas_parametros = [user_cuentas_parametros]
        }

        // Quitamos la cotraseña ya que no es un dato que vayamos a necesitar
        delete user_data.password;

        localStorage.setItem("siam-module-menu", JSON.stringify(module_menu));
        localStorage.setItem("siam-user-data", JSON.stringify(user_data));
        localStorage.setItem("siam-user-cuentas", JSON.stringify(user_cuenta))
        
        localStorage.setItem("siam-user-cuentas-localizaciones", JSON.stringify(user_cuentas_localizaciones))

        localStorage.setItem("siam-user-cuentas-parametros", JSON.stringify(user_cuentas_parametros))

        await populateServiceData();

        localStorage.setItem(`openSideMenu`, false);
    }
    return response;
};

export const getData = (data) => {
    return JSON.parse(localStorage.getItem(data));
};
